<template>
  <div class="config-form-content weeduc-admin-config adminWeeducConfig weflix-admin-layoutThemes" v-if="hasReady">
    <div class="row g-3 g-lg-4 weeduc-admin-config-layout mx-0">
      <div class="col-12 weeduc-admin-config-col">
        <div class="weeduc-admin-config-section">
          <h3 class="weeduc-admin-config-section-title">Tema do site</h3>
          <p class="weeduc-admin-config-section-lead">Escolha o visual das páginas públicas do Weflix.</p>
          <div class="weflix-theme-grid">
            <button
              type="button"
              class="weflix-theme-card"
              :class="{ 'weflix-theme-card--active': isNetflixThemeSelected }"
              :aria-pressed="isNetflixThemeSelected"
              @click="alterarActiveTheme(0)"
            >
              <img src="@/assets/Weflix/theme2.png" alt="Tema Netflix">
              <div>
                <h4>Netflix</h4>
                <p>Visual escuro, com menos fadiga visual e o conteúdo em destaque.</p>
              </div>
            </button>
            <button
              type="button"
              class="weflix-theme-card"
              :class="{ 'weflix-theme-card--active': isLightThemeSelected }"
              :aria-pressed="isLightThemeSelected"
              @click="alterarActiveTheme(1)"
            >
              <img src="@/assets/Weflix/theme1.png" alt="Tema Light">
              <div>
                <h4>Light</h4>
                <p>Visual claro e minimalista, com leitura leve e direta.</p>
              </div>
            </button>
          </div>
        </div>
      </div>
      <div class="col-12 weeduc-admin-config-col">
        <div class="weeduc-admin-config-section">
          <h3 class="weeduc-admin-config-section-title">Exibição</h3>
          <p class="weeduc-admin-config-section-lead">Defina como capas e títulos aparecem no catálogo.</p>
          <div class="row g-3">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label class="form-label" for="coverFormatSelect">Formato da capa do curso</label>
                <select id="coverFormatSelect" v-model="typeImageCoverCourse" class="form-input">
                  <option value="1">Capa horizontal (1920 x 200px)</option>
                  <option value="2">Capa vertical (240 x 440px)</option>
                </select>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label class="form-label" for="visibleTitleCourseSelect">Exibir títulos dos vídeos</label>
                <select id="visibleTitleCourseSelect" v-model="visibleTitleCourse" class="form-input">
                  <option :value="true">Sim</option>
                  <option :value="false">Não</option>
                </select>
              </div>
            </div>
          </div>
          <div class="buttons-container weeduc-admin-site-form-actions">
            <div class="button d-flex flex-wrap gap-2 justify-content-end">
              <button type="button" class="btn btn-block btn-content" @click="updateWebsite">Salvar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Loader :hasReady="hasReady"/>
</template>


<script>
import websiteApi from '@/utils/Weflix/website';
import { mapState, mapActions } from 'vuex';
import Loader from '@/components/Weflix/Loader.vue';
import { toast } from 'vue3-toastify';

export default {
  data(){
      return{
          // Todos os campos vindos da API
          id: '',
          nome: '',
          url: '',
          url1: null,
          url2: null,
          title: '',
          description: '',
          keywords: null,
          logo: '',
          color: '',
          favicon: '',
          logoFinal: '',
          faviconFinal: '',
          status: null,
          tagManagerCode: '',
          typeLayout: null,
          javascript: '',
          css: null,
          typeLayoutPortal: null,
          googleAnalyticsCode: '',
          facebookPixelCode: '',
          dateInsert: '',
          email: null,
          phone: null,
          numberCollection: null,
          numberVideo: null,
          timeVideo: null,
          numberSubscription: null,
          about: '',
          termUse: null,
          typeImageCoverCourse: null,
          visibleTitleCourse: null,
          googleAdsCode: '',
          rdsecretClient: '',
          rdclienteId: '',
          rdcode: '',
          rdrefreshToken: '',
          // Controle de carregamento
          hasReady: false,
      }
  },
  computed: {
    ...mapState(['token']),
    isNetflixThemeSelected() {
      if (this.typeLayout === null || this.typeLayout === undefined || this.typeLayout === '') {
        return false;
      }
      return Number(this.typeLayout) === 0;
    },
    isLightThemeSelected() {
      if (this.typeLayout === null || this.typeLayout === undefined || this.typeLayout === '') {
        return false;
      }
      return Number(this.typeLayout) === 1;
    },
  },
  components: {
      Loader,
  },
  methods: {
    ...mapActions(['storeLayoutWebsite']),
    /** API pode enviar número ou string; tema portal às vezes vem só em typeLayoutPortal. */
    normalizeTheme01(a, b) {
      for (const v of [a, b]) {
        if (v === null || v === undefined || v === '') continue;
        const n = Number(v);
        if (n === 0 || n === 1) return n;
      }
      return null;
    },
    fillPreviewData() {
      if (this.typeLayout === null || this.typeLayout === undefined || this.typeLayout === '') {
        this.alterarActiveTheme(0);
      }
      if (this.typeImageCoverCourse == null || this.typeImageCoverCourse === '') {
        this.typeImageCoverCourse = '1';
      }
      if (this.visibleTitleCourse == null || this.visibleTitleCourse === '') {
        this.visibleTitleCourse = true;
      }
    },
    alterarActiveTheme(novoTema) {
      this.typeLayout = Number(novoTema);
    },
    async getWebsite() {
      const response = await websiteApi.getWebsite(this.token);
      // Preenche todos os campos vindos da API
      this.id = response.id;
      this.nome = response.nome;
      this.url = response.url;
      this.url1 = response.url1;
      this.url2 = response.url2;
      this.title = response.title;
      this.description = response.description;
      this.keywords = response.keywords;
      this.logo = response.logo;
      this.color = response.color;
      this.favicon = response.favicon;
      this.logoFinal = response.logoFinal;
      this.faviconFinal = response.faviconFinal;
      this.status = response.status;
      this.tagManagerCode = response.tagManagerCode;
      this.typeLayout = this.normalizeTheme01(
        response.typeLayout,
        response.typeLayoutPortal
      );
      this.javascript = response.javascript;
      this.css = response.css;
      this.typeLayoutPortal = response.typeLayoutPortal;
      this.googleAnalyticsCode = response.googleAnalyticsCode;
      this.facebookPixelCode = response.facebookPixelCode;
      this.dateInsert = response.dateInsert;
      this.email = response.email;
      this.phone = response.phone;
      this.numberCollection = response.numberCollection;
      this.numberVideo = response.numberVideo;
      this.timeVideo = response.timeVideo;
      this.numberSubscription = response.numberSubscription;
      this.about = response.about;
      this.termUse = response.termUse;
      this.typeImageCoverCourse = response.typeImageCoverCourse;
      this.visibleTitleCourse = response.visibleTitleCourse == 1 ? true : false;
      this.googleAdsCode = response.googleAdsCode;
      this.rdsecretClient = response.rdsecretClient;
      this.rdclienteId = response.rdclienteId;
      this.rdcode = response.rdcode;
      this.rdrefreshToken = response.rdrefreshToken;
      this.hasReady = true;
    },
    async updateWebsite() {
      this.hasReady = false;
      // Monta o payload com todos os campos, mas só atualiza os do componente
      const payload = {
        nome: this.nome,
        url: this.url,
        url1: this.url1,
        url2: this.url2,
        title: this.title,
        description: this.description,
        keywords: this.keywords,
        logo: this.logo,
        color: this.color,
        favicon: this.favicon,
        logoFinal: this.logoFinal,
        faviconFinal: this.faviconFinal,
        status: this.status,
        tagManagerCode: this.tagManagerCode,
        typeLayout: this.typeLayout,
        javascript: this.javascript,
        css: this.css,
        typeLayoutPortal: this.typeLayoutPortal,
        googleAnalyticsCode: this.googleAnalyticsCode,
        facebookPixelCode: this.facebookPixelCode,
        dateInsert: this.dateInsert,
        email: this.email,
        phone: this.phone,
        numberCollection: this.numberCollection,
        numberVideo: this.numberVideo,
        timeVideo: this.timeVideo,
        numberSubscription: this.numberSubscription,
        about: this.about,
        termUse: this.termUse,
        typeImageCoverCourse: this.typeImageCoverCourse,
        visibleTitleCourse: this.visibleTitleCourse ? 1 : 0,
        googleAdsCode: this.googleAdsCode,
        rdsecretClient: this.rdsecretClient,
        rdclienteId: this.rdclienteId,
        rdcode: this.rdcode,
        rdrefreshToken: this.rdrefreshToken
      };
      this.storeLayoutWebsite({ layoutWebsite: payload });
      try {
        await websiteApi.editWebsite(this.token, this.id, payload);
        this.getWebsite();
        this.hasReady = true;
        this.notify('Tema atualizado com sucesso!', 'success');
      } catch (error) {
        this.notify('Erro ao atualizar tema.', 'error');
        console.error('Erro ao atualizar dados do website:', error);
      }
    },
    notify(message, type = "info") {
      toast(message, {
        autoClose: 3000,
        position: 'top-right',
        theme: "light", 
        limit: 1,
        type: type,
        dangerouslyHTMLString: true
      });
    },
  },  
  created() {
      this.getWebsite()
    }
}
</script>

<style scoped>
@import '@/css/weeduc/admin/config.css';

.weflix-theme-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.weflix-theme-card {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  width: 100%;
  text-align: left;
  padding: 0.85rem;
  border-radius: 12px;
  border: 1px solid #e8eaf0;
  background: #fff;
  cursor: pointer;
  color: inherit;
}

.weflix-theme-card img {
  display: block;
  width: 100%;
  height: 360px;
  object-fit: contain;
  object-position: center;
  border-radius: 8px;
  background: #f7f8fb;
}

.weflix-theme-card h4 {
  margin: 0 0 0.25rem;
  font-size: 1rem;
  font-weight: 700;
  color: #1a1d26;
}

.weflix-theme-card p {
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.45;
  color: #6b7280;
}

.weflix-theme-card--active {
  border-color: #250891;
  box-shadow: 0 0 0 3px rgba(37, 8, 145, 0.12);
}

:global(.dashboard.dark) .weflix-theme-card {
  background: #2a2d36;
  border-color: #3d414d;
}

:global(.dashboard.dark) .weflix-theme-card h4 {
  color: #f1f3f7;
}

:global(.dashboard.dark) .weflix-theme-card p {
  color: #9ca3b4;
}

@media (max-width: 700px) {
  .weflix-theme-grid {
    grid-template-columns: 1fr;
  }
}
</style>
